import { LegacyRef, forwardRef } from 'react';
import * as React from 'react';

interface CustomInputProps extends React.HTMLProps<HTMLInputElement> {
  id: string;
  label: string;
  description?: string;
  disabled?: boolean;
  error?: string;
  helperText?: string;
}

const CustomInput = forwardRef(
  (props: CustomInputProps, ref: LegacyRef<HTMLInputElement>) => {
    const {
      id,
      label,
      disabled = false,
      description,
      error,
      helperText,
      ...inputProps
    } = props;
    return (
      <div
        className={`xpl-input w-full flex-col mb-[15px] ${
          helperText ? '' : 'h-[68px]'
        }`}
      >
        <label htmlFor={id} className='text-sm font-medium'>
          {label}
        </label>
        {!!description && (
          <p
            className='font-sans text-base font-normal leading-4 tracking-normal text-left text-gray-700
'
          >
            {description}
          </p>
        )}
        <div
          className={`xpl-input-wrapper h-[44px] ${
            disabled && 'bg-gray-disabled'
          } ${error ? 'mb-0' : helperText ? 'mb-1' : 'mb-5'}`}
        >
          <input
            id={id}
            ref={ref}
            disabled={disabled}
            placeholder={label}
            type='text'
            className={`appearance-none focus:outline-none focus:ring-0 pl-0`}
            style={{ color: '#6a6d7d' }}
            data-test-id={id}
            {...inputProps}
          />
        </div>
        {error && <p className='text-red-500 leading-5 text-xs'>{error}</p>}
        {helperText && <p className='text-xs text-gray-500'>{helperText}</p>}
      </div>
    );
  },
);

export default CustomInput;
